// extracted by mini-css-extract-plugin
var _1 = "EntityProfileTabUpdatesList-modulefooter__w5VYd";
var _2 = "EntityProfileTabUpdatesList-modulelist__Ap0cJ";
var _3 = "EntityProfileTabUpdatesList-moduleshowAllButton__idnny";
export { _1 as "footer", _2 as "list", _3 as "showAllButton" }
